import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=ddc031d8&scoped=true"
import script from "./vouchers.vue?vue&type=script&lang=js"
export * from "./vouchers.vue?vue&type=script&lang=js"
import style0 from "./vouchers.vue?vue&type=style&index=0&id=ddc031d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc031d8",
  null
  
)

export default component.exports